import './styles.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container footerInner">
        <div className="footerBrand">
          <span className="brandMark" aria-hidden="true">
            D
          </span>
          <div>
            <div className="footerTitle">DaoCampus</div>
            <p className="footerBrandCopy">Empowering European students to collaborate beyond borders.</p>
            <a className="footerEmail" href="mailto:contact@daocampus.org">
              contact@daocampus.org
            </a>
          </div>
        </div>

        <div className="footerBottom">
          <p>© 2026 DaoCampus Inc. All rights reserved.</p>
          <p>English (EU)</p>
        </div>
      </div>
    </footer>
  );
}
